import { Box, MenuItem, TextField, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
// import {
//   LiveChatWidget,
//   EventHandlerPayload,
//   useWidgetIsReady,
//   useWidgetState,
// } from "@livechat/widget-react";
import "./menu.bar.css";
import menu from "../../assets/icons/menu/menu.svg";
import home from "../../assets/icons/menu/home.svg";
import personal_account from "../../assets/icons/menu/personal_account.svg";
import wallet from "../../assets/icons/menu/wallet.svg";
import recommended from "../../assets/icons/menu/recommended.svg";
import slots from "../../assets/icons/menu/slots.svg";
import buy_bonus from "../../assets/icons/menu/buy_bonus.svg";
import live_casino from "../../assets/icons/menu/live_casino.svg";
import roulette from "../../assets/icons/menu/roulette.svg";
import rocket from "../../assets/icons/menu/rocket.svg";
import card_games from "../../assets/icons/menu/card_games.svg";
import mega_ways from "../../assets/icons/menu/mega_ways.svg";
import bonuses from "../../assets/icons/menu/bonuses.svg";
import partners from "../../assets/icons/menu/partners.svg";
import support from "../../assets/icons/menu/support.svg";
import info from "../../assets/icons/menu/info.svg";
import telegram from "../../assets/icons/menu/telegram.svg";
import popular from "../../assets/icons/menu/popular.svg";
import bell from "../../assets/icons/menu/bell.svg";
import jackpots from "../../assets/icons/menu/jackpots.svg";
import profile_arrow from "../../assets/icons/menu/profile_arrow.svg";
import close from "../../assets/icons/menu/close.svg";
import { useMediaQuery } from "react-responsive";
import { useAppDispatch } from "../../store/hooks/store.hooks";
import { changeLanguageThunk } from "../../store/models/profile/profile.thunk";
import { IntercomComponent } from "../intercom/intercom";
// import { IJivoSelector } from "../jivo/typing/jivo.interface";
// import { jivoSelector } from "../jivo/jivo.selector";
// import { useAppSelector } from "../../store/hooks/store.hooks";
// import { userChatName } from "../../utils/chatNameFormat";
import { show } from "@intercom/messenger-js-sdk";

interface IMenuBarProps {
  menuOpened: boolean;
  setMenuOpened: React.Dispatch<React.SetStateAction<boolean>>;
}
export const MenuBar = ({ menuOpened, setMenuOpened }: IMenuBarProps) => {
  const { t, i18n } = useTranslation();
  const initValue = i18n.resolvedLanguage || i18n.language;
  const [select, setSelect] = useState(initValue);
  const dispatch = useAppDispatch();
  // const { loyaltyLevel, email, phone, id }: IJivoSelector =
  //   useAppSelector(jivoSelector);
  const isMobile = useMediaQuery({ maxWidth: 600 });
  // const widgetState = useWidgetState();
  // const isWidgetReady = useWidgetIsReady();

  // useEffect(() => {
  //   if (widgetState) {
  //     setChatState(widgetState.visibility);
  //   }
  // }, [widgetState]);

  // function handleNewEvent(event: EventHandlerPayload<"onNewEvent">) {
  //   // console.log("LiveChatWidget.onNewEvent", event);
  // }
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const [profileOpened, setProfileOpened] = useState(false);
  const navigate = useNavigate();
  const navigateHandler = (path: string) => {
    setProfileOpened(false);
    if (isMobile) {
      setMenuOpened(false);
    }

    navigate(path);
  };
  useEffect(() => {
    if (!menuOpened) {
      setProfileOpened(false);
    }
  }, [menuOpened]);

  return (
    <Box
      className={menuOpened ? "menu opened" : "menu"}
      onClick={() => {
        setMenuOpened(true);
      }}
    >
      <Box
        className="menu__header"
        onClick={(e) => {
          e.stopPropagation();
          setMenuOpened(!menuOpened);
        }}
      >
        {menuOpened ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              gap: "26px",
              alignItems: "center",
              padding: "0 24px",
            }}
          >
            <img
              src={close}
              alt="Close"
              loading="lazy"
              className="menu__block-item-icon"
            />
            <Box
              sx={{
                width: "calc(108px - 60px)",
                backgroundColor: "#FFFFFF1A",
                padding: "6px 30px",
                borderRadius: "var(--primary-border-radius)",
                fontSize: "12px",
                lineHeight: "24px",
                fontWeight: "600",
                color: "var(--primary-text-color)",
                textTransform: "uppercase",
              }}
            >
              {t("main.menuItems.menu")}
            </Box>
          </Box>
        ) : (
          <img
            src={menu}
            alt="Menu"
            loading="lazy"
            className="menu__block-item-icon"
          />
        )}
      </Box>
      <Box className="menu__container">
        <Box className="menu__block">
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/");
            }}
          >
            <img
              src={home}
              alt="Home"
              loading="lazy"
              className="menu__block-item-icon"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.main")}
            </Box>
          </Box>
          <Box
            className={
              profileOpened
                ? "menu__block-item active list-item"
                : "menu__block-item list-item"
            }
            onClick={() => {
              setProfileOpened(!profileOpened);
            }}
          >
            <Box>
              <img
                src={personal_account}
                alt="Profile"
                className="menu__block-item-icon"
                loading="lazy"
              />
              <Box className="menu__block-item-text">
                {t("main.menuItems.profile")}
              </Box>
              <Box className="menu__block-profile-arrow">
                <img src={profile_arrow} alt="arrow" loading="lazy" />
              </Box>
            </Box>
            {profileOpened && (
              <Box className="list-item__container">
                <Box
                  className="list-item__item"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigateHandler("/profile");
                  }}
                >
                  {t("main.menuItems.personal")}
                </Box>
                <Box
                  className="list-item__item"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigateHandler("/profile/payments");
                  }}
                >
                  {t("main.menuItems.payments")}
                </Box>
                <Box
                  className="list-item__item"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigateHandler("/profile/bonuses");
                  }}
                >
                  {t("main.menuItems.my_bonuses")}
                </Box>
                <Box
                  className="list-item__item"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigateHandler("/profile/security");
                  }}
                >
                  {t("main.menuItems.security")}
                </Box>
              </Box>
            )}
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/profile/payments");
            }}
          >
            <img
              src={wallet}
              alt="Deposit"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.deposit")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/lobby/slots?popular=true");
            }}
          >
            <img
              src={popular}
              alt="Popular"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.popular")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/lobby/slots?newGame=true");
            }}
          >
            <img
              src={bell}
              alt="New"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.new")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/lobby/slots?recommended=true");
            }}
          >
            <img
              src={recommended}
              alt="Recommended"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.recommended")}
            </Box>
          </Box>
        </Box>
        <Box className="menu__block">
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/lobby/slots");
            }}
          >
            <img
              src={slots}
              alt="Slots"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.slots")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/lobby/slots?buy_fs=true");
            }}
          >
            <img
              src={buy_bonus}
              alt="Buy Bonus"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.bonus_buy")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/lobby/slots?category=jackpots");
            }}
          >
            <img
              src={jackpots}
              alt="Jackpots"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.jackpots")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/lobby/live");
            }}
          >
            <img
              src={live_casino}
              alt="Live"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.live")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/lobby/crash");
            }}
          >
            <img
              src={rocket}
              alt="Rocket"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.crash")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/lobby/live?category=roulette");
            }}
          >
            <img
              src={roulette}
              alt="Roulette"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.roulette")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/lobby/live?category=card_games");
            }}
          >
            <img
              src={card_games}
              alt="Card Games"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.card_games")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/lobby/slots?category=megaways");
            }}
          >
            <img
              src={mega_ways}
              alt="MegaWays"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.mega_ways")}
            </Box>
          </Box>
        </Box>
        <Box className="menu__block">
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/bonuses");
            }}
          >
            <img
              src={bonuses}
              alt="Bonuses"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.bonuses")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/partner");
            }}
          >
            <img
              src={partners}
              alt="Partners"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.partner")}
            </Box>
          </Box>
          {/* <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/club");
            }}
          >
            <img
              src={club}
              alt="Club"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.club")}
            </Box>
          </Box> */}
        </Box>
        <Box className="menu__block">
          <TextField
            className="menu__block-item-language"
            select
            size="small"
            id="language-footer"
            name="language-footer"
            value={select}
          >
            <MenuItem
              sx={{
                "& img": {
                  marginRight: "10px",
                },
              }}
              onClick={() => {
                setSelect("en");
                changeLanguage("en");
              }}
              value={"en"}
            >
              <img src={"https://flagcdn.com/w20/gb.png"} alt="English" />
              <Typography>English</Typography>
            </MenuItem>
            <MenuItem
              sx={{
                "& img": {
                  marginRight: "10px",
                },
              }}
              onClick={() => {
                setSelect("ru");
                changeLanguage("ru");
              }}
              value={"ru"}
            >
              <img src={"https://flagcdn.com/w20/ru.png"} alt="Russian" />
              <Typography>Русский</Typography>
            </MenuItem>
            <MenuItem
              sx={{
                "& img": {
                  marginRight: "10px",
                },
              }}
              onClick={() => {
                setSelect("tr");
                changeLanguage("tr");
              }}
              value={"tr"}
            >
              <img src={"https://flagcdn.com/w20/tr.png"} alt="Turkish" />
              <Typography>Turkish</Typography>
            </MenuItem>
          </TextField>
        </Box>
        <Box className="menu__block">
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              show();
            }}
          >
            <img
              src={support}
              alt="Support"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.support")}
            </Box>
          </Box>
          <Box
            className="menu__block-item"
            onClick={(e) => {
              e.stopPropagation();
              navigateHandler("/policy");
            }}
          >
            <img
              src={info}
              alt="Information"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.information")}
            </Box>
          </Box>
          <a
            target="_blank"
            href="https://t.me/EnomoCasino"
            className="menu__block-item"
            style={{
              textDecoration: "none",
              color: "var(--primary-text-color) !important",
              fontSize: "14px !important",
              lineHeight: "14px !important",
              fontWeight: "500 !important",
            }}
            rel="noreferrer"
          >
            <img
              src={telegram}
              alt="Telegram"
              className="menu__block-item-icon"
              loading="lazy"
            />
            <Box className="menu__block-item-text">
              {t("main.menuItems.telegram")}
            </Box>
          </a>
        </Box>
      </Box>
      <IntercomComponent />
      {/* <LiveChatWidget
        license="18252378"
        visibility={chatState}
        customerName={userChatName(id, loyaltyLevel)}
        customerEmail={email || undefined}
        onNewEvent={handleNewEvent}
      /> */}
    </Box>
  );
};
